export const BUS_BOOKING_FORM_TOGGLE_FILL_PAX_DETAILS =
  'BUS/TOGGLE_FILL_PAX_DETAILS_BOOKING_FORM';

export default function toggleFillPaxDetails() {
  return {
    type: BUS_BOOKING_FORM_TOGGLE_FILL_PAX_DETAILS,
  };
}
